import VueCookies from 'vue-cookies';
import accountService from '@/services/account/auth-account';
import router from '@/router';

// State
const state = {
	status: {
		loggedIn: false
	},
	user: null
}

// Getters
const getters = {
	loggedIn: state => state.status.loggedIn,
	username: state => state.user.fullname.split('@')[0],
	user: state => state.user,
	userId: state => state.user._id,
	userRole: state => state.user.role.key,
	userRoleWeight: state => state.user?.role.weight || 0,
	userOrganizations: state => state.user?.organizations || undefined,
	userOrganizationsIds: state => state.user?.organizations.map(entry => entry._id) || undefined
}

// Actions
const actions = {
	async signin({ dispatch }, { username, password }) {		
		const res = await accountService.signin(username, password)
		
		if (res.status !== 200)  {
			throw new Error(res.statusText)
		}
		
		if (res.data.err) {
			throw new Error(res.data.res)
		}
					
		await dispatch('getUserData')
	},
	async getUserData({commit}) {
		try {
			const result = await accountService.getUserData()
			
			if (result.err) throw new Error(result.res);

			if (result.data.res.role.weight >= 10) {
				VueCookies.set('logged-in','yes', 0)
				commit('loginSuccess')
			} else {
				VueCookies.set('logged-in','no')
				commit('logout')
			}			
			
			commit('AuthenticateUser', result.data.res)
		} catch (e) {
			return e
		}
	},
	async logout({commit}) {
		try {
			await accountService.logout();
			VueCookies.set('logged-in','no')
			commit('logout');

			setTimeout(() => {
				router.push('/');
			}, 100);
		} catch (e) {
			console.log(e);
		}
	}
}

// Mutations
const mutations = {
    loginSuccess(state) {
        state.status = {
			loggedIn: true
		};
    },
    loginFailure(state, message) {
        state.status = { 
			loggedIn: false,
			failedLogin: true,
			message: message,
		};
        state.user = null;
    },
	AuthenticateUser(state, user) {
        state.user = user;
    },
	logout(state) {
        state.status = {
			loggedIn: false
		};
        state.user = null;
    },
};

export default {
    namespaced: true,
    state,
	getters,
    actions,
    mutations,
};
